// @flow
import _ from 'lodash';
import invariant from 'invariant';

import { asyncCall } from './async';

const hasMethod = <T>(instance: T, methodName: string): boolean => _.isFunction(instance[methodName]);

const tryCallMethod = <T>(methodName: string, instance: T, args: *[]): void => {

	if (!hasMethod(instance, methodName)) {
		return; // silent
	}

	instance[methodName](...(args || []));
};

const tryGetMethodResult = <T>(methodName: string, instance: T, args: *[]) => {

	if (!hasMethod(instance, methodName)) {
		return; // silent
	}

	// eslint-disable-next-line consistent-return
	return instance[methodName](...(args || []));
};

const tryCallPromisifyMethod = async (methodName: string, instance: Class<*>, args: *[]): void => {

	if (!hasMethod(instance, methodName)) {
		return; // silent
	}

	await instance[methodName](...(args || []));
};


const tryCallMethodAsync = <T>(methodName: string, instance: T, args: *[]): void => {

	if (!hasMethod(instance, methodName)) {
		return; // silent
	}

	asyncCall(() => instance[methodName](...args));
};


const shouldImplementContractByMethod = <T>(instance: T, methodName: string): void => {
	invariant(hasMethod(instance, methodName), `Instance should have a method - "${methodName}" `);

	instance[methodName]();
};

export {
	tryCallMethod,
	tryCallMethodAsync,
	tryGetMethodResult,
	tryCallPromisifyMethod,
	shouldImplementContractByMethod,
};
